<template>
  <div class="page-loading">
    <svg-icon name="loader" />
  </div>
</template>
<script>
export default {
  name: 'Loading'
}
</script>
<style lang="scss" scoped>
  @import "@/styles/variables";

  .page-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;

    svg {
      width: 5rem;
      height: auto;
      color: $theme-color-1;
    }
  }
</style>